var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',{attrs:{"clas":"wh-100"}},[(_vm.connected)?_c('loading-screen',{attrs:{"ready":_vm.ready}}):_vm._e(),(_vm.connected)?_c('router-view'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }